import React from "react";

export default function GlobalCommunity() {
  return (
    <div>
      <div class="global_community_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="global_comm_wraper">
              <h1>We Were Always Thinking Global Community</h1>
              <p>
                At treasure growth investment, we believe there is no better
                advertisement than satisfied clients. No wonder that majority of
                our new clients are affiliates from our existing clients. We are
                proud that our clients like to recommend our financial service
                to others. Because of this, we are pleased to offer one of the
                strongest online affiliate programs in the financial service
                industry, with a high commission rate, customized tools and
                reports, and timely commission payouts.
                treasuregrowthinvestment.com is paying for the popularization of
                its investment program and anyone can be rewarded. To benefit
                from this, you have to tell your friends,relatives or colleagues
                about our company.
              </p>
            </div>
            <div class="zero_balance_wrapper">
              <div class="zero_commisition">
                <h1>Zero Commissions</h1>
                <h4>No hidden charges*</h4>
              </div>
              <div class="start_invest_wrap">
                <h1>start invest now</h1>
                <div class="about_btn float_left">
                  <ul>
                    <li>
                      <a href="#">Get started !</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
